import React, { Fragment } from "react";

import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function VlmDisplay({ vlm_for_display }) {
  return (
    <Fragment>
      <Typography variant="h6">Variable Level Metadata</Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Variable Name</TableCell>
              <TableCell>Variable Label</TableCell>
              <TableCell>Observed Datatype</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vlm_for_display.map((row, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{row.var_name}</TableCell>
                <TableCell>{row.var_label}</TableCell>
                <TableCell>{row.obs_data_type}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
}

export default VlmDisplay;
